import { Button } from '@mui/material'
import { useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const AppMenu = (): JSX.Element => {
  const { t } = useTranslation()
  const [anchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const navigate = useNavigate()
  return (
    <div>
      <Button
        id="btnUser"
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={() => navigate('/merchant/browse', { replace: true })}
      >
        {t('common.merchant')}
      </Button>
    </div>
  )
}

export default AppMenu
